const SCRATCHCARD_ENCODED_TICKET_PREFIX = 'SCD';
const ENCODED_TICKET_SEPARATOR = ';';

/**
 * Builds the encoded cart ticket the backend expects for scratchcards: `SCD;<title>;<quantity>`.
 * @param title - The scratchcard title
 * @param quantity - The number of scratchcards
 * @returns The encoded ticket string
 */
function buildScratchcardEncodedTicket(title: string, quantity: number): string {
  return [SCRATCHCARD_ENCODED_TICKET_PREFIX, title, quantity].join(ENCODED_TICKET_SEPARATOR);
}

export { buildScratchcardEncodedTicket };
